import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import 'bootstrap/dist/css/bootstrap.min.css';
import './ColorSchemesExample.css';

function ColorSchemesExample() {
  const navigate = useNavigate();
  const location = useLocation();

  const [activeLink, setActiveLink] = useState(location.pathname);
  const [expanded, setExpanded] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleNavigation = (path) => {
    navigate(path);
    setActiveLink(path);
    setExpanded(false);
  };

  return (
    <div className="navbar-overlay">
      <Navbar
        expand="lg"
        fixed="top"
        variant="dark"
        expanded={expanded}
        className={`navbar-transparent ${scrolled ? "navbar-scrolled" : ""} ${expanded ? "menu-open" : ""}`}
      >
        <Container>

          {/* LOGO */}
          <Navbar.Brand className="navbar-brand-custom">
            <img
              src={`${process.env.PUBLIC_URL}/logo.png`}
              width="20"
              height="20"
              alt="Logo"
              className="logo-img"
            />
            <span className="logo-text">
              Libyan Engineering Consulting Co
            </span>
          </Navbar.Brand>

          {/* CUSTOM HAMBURGER */}
          <button
            className={`custom-toggler d-lg-none ${expanded ? "open" : ""}`}
            onClick={() => setExpanded(!expanded)}
          >
            <span></span>
            <span></span>
          </button>

          {/* FULLSCREEN MENU */}
          <Navbar.Collapse className={`fullscreen-menu ${expanded ? "show" : ""}`}>
            <Nav className="fullscreen-nav">

              <Nav.Link
                as={Link}
                to="/"
                onClick={() => handleNavigation("/")}
                className={activeLink === "/" ? "active" : ""}
              >
                Home
              </Nav.Link>

              <Nav.Link
                as={Link}
                to="/about"
                onClick={() => handleNavigation("/about")}
                className={activeLink === "/about" ? "active" : ""}
              >
                About
              </Nav.Link>

              <Nav.Link
                as={Link}
                to="/journal"
                onClick={() => handleNavigation("/journal")}
                className={activeLink === "/journal" ? "active" : ""}
              >
                Journal
              </Nav.Link>

              <Nav.Link
                as={Link}
                to="/contacts"
                onClick={() => handleNavigation("/contacts")}
                className={activeLink === "/contacts" ? "active" : ""}
              >
                Contacts
              </Nav.Link>

            </Nav>
          </Navbar.Collapse>

          {/* DESKTOP MENU */}
          <div className="desktop-nav-links d-none d-lg-flex">
            <Nav>
              <Nav.Link as={Link} to="/" onClick={() => handleNavigation("/")}>Home</Nav.Link>
              <Nav.Link as={Link} to="/about" onClick={() => handleNavigation("/about")}>About</Nav.Link>
              <Nav.Link as={Link} to="/journal" onClick={() => handleNavigation("/journal")}>Journal</Nav.Link>
              <Nav.Link as={Link} to="/contacts" onClick={() => handleNavigation("/contacts")}>Contacts</Nav.Link>
            </Nav>
          </div>

        </Container>
      </Navbar>
    </div>
  );
}

export default ColorSchemesExample;